import Helmet from 'components/Helmet'
import About from '../components/About'
import Achievement from '../components/Achievement'
import Experience from '../components/Experience'
import Feedback from '../components/FeedBack'
import Hobbies from '../components/Hobbies'
import './styles.scss'

function LandingPage() {
  return (
    <Helmet title="Portfolio">
      <div className="landing-page">
        <About />
        <Experience />
        <Hobbies />
        <Achievement />
        <Feedback />
      </div>
    </Helmet>
  )
}

export default LandingPage
